export default __webpack_public_path__ + "static/media/Eye.c799cbd2.svg";